import { render } from "./StudentStatistics.vue?vue&type=template&id=0ab00cc0&scoped=true"
import script from "./StudentStatistics.vue?vue&type=script&lang=js"
export * from "./StudentStatistics.vue?vue&type=script&lang=js"

import "./StudentStatistics.vue?vue&type=style&index=0&id=0ab00cc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab00cc0"]])

export default __exports__